import Grid from '@jobcost-monorepo/crud/ui/Grid';
import { IListUserFetchParams, IUser, MN_USERS } from '@jobcost-monorepo/crud';

export default function UsersPage() {
  return (
    <>
      <Grid<IUser, IListUserFetchParams>
        moduleName={MN_USERS}
        updateStore={false}
      ></Grid>
    </>
  );
}
